<template>
	<div>
		<div class="container-fluid conteudo">
			<cabecalho-modelo
				:titulo="titulo"
				:sub-titulo="subTitulo"
				:submenu-modulo="submenuModulo"
				:icon-cabecalho="iconCabecalho"
				@click-novo="clickNovo"
				exibe-cadastro
				v-if="exibeCabecalho"
				:exibe-opicoes="exibeOpicoes"
			/>

			<div class="text-center" v-show="carregando">
				<flCarregando />
			</div>
			<div v-show="!carregando">
				<Tabela
					:rota="rota"
					:server-side="serverSide"
					:dados-tabela="dadosTabela"
					:colunas-tabela="colunasTabela"
					:colunas-filtro="colunasFiltro"
					:label-item="labelItem"
					:coluna-descricao="colunaDescricao"
					:exibe-editar="exibeEditar"
					:exibe-visualizar-impressao="exibeVisualizarImpressao"
					:exibe-excluir="exibeExcluir"
					:exibe-concluir="exibeConcluir"
					:exibe-parecer="exibeParecer"
					:exibe-busca="exibeBusca"
					:usar-busca-avancada="usarBuscaAvancada"
					:exibe-cancelar="exibeCancelar"
					:exibe-atualizar="exibeAtualizar"
					:exibe-excluir-coluna="exibeExcluirColuna"
					:exibe-excluir-inverter="exibeExcluirInverter"
					:sentido-padrao="sentidoPadrao"
					@click-editar="clickEditar"
					@click-visualizar-impressao="clickVisualizarImpressao"
					@click-concluir="clickConcluir"
					@click-parecer="clickParecer"
					@click-excluir="clickExcluir"
					@click-cancelar="clickCancelar"
					@click-atualizar="clickAtualizar"
				>
					<template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
						<slot :name="name" v-bind="data"></slot>
					</template>
				</Tabela>
			</div>
		</div>
	</div>
</template>

<script>
import Tabela from './tabela.vue'

export default {
	components: {
		Tabela
	},

	props: {
		titulo: {
			type: String,
			required: true
		},

		subTitulo: {
			type: String,
			required: false
		},

		iconCabecalho: {
			type: String,
			required: false,
			default: 'icon-novo_cadastro'
		},

		dadosTabela: {
			type: Array,
			default: () => []
		},

		colunasTabela: {
			type: Array,
			required: true
		},

		labelItem: {
			type: String,
			required: true
		},

		colunaDescricao: {
			type: String,
			required: true
		},

		colunasFiltro: {
			type: Array,
			required: false,
			default: () => []
		},

		carregando: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluirColuna: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluirInverter: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeCadastro: {
			type: Boolean,
			required: false,
			default: true
		},

		exibeEditar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeVisualizarImpressao: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeConcluir: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeParecer: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluir: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeCancelar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeAtualizar: {
			type: Boolean,
			required: false,
			default: false
		},

		submenuModulo: {
			type: String,
			required: false,
			default: 'ad'
		},

		exibeCabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		serverSide: {
			type: Boolean,
			default: false
		},

		rota: {
			type: String,
			default: ''
		},

		exibeBusca: {
			type: Boolean,
			required: false,
			default: true
		},

		usarBuscaAvancada: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeOpicoes: {
			type: Boolean,
			required: false,
			default: true
		},

		sentidoPadrao:{
			type: Boolean,
			required: false,
			default: true
		}
	},

	data() {
		return {
			busca: '',
			cadastroNovo: true
		}
	},

	methods: {
		clickNovo() {
			this.cadastroNovo = true
			this.$emit('click-novo')
		},

		clickEditar(itemTabela) {
			this.cadastroNovo = false
			this.$emit('click-editar', itemTabela)
		},

		clickVisualizarImpressao(itemTabela) {
			this.$emit('click-visualizar-impressao', itemTabela)
		},

		clickConcluir(itemTabela) {
			this.$emit('click-concluir', itemTabela)
		},

		clickParecer(itemTabela) {
			this.$emit('click-parecer', itemTabela)
		},

		clickExcluir(itemTabela, atualizarTabelaServerSide = null) {
			this.$emit('click-excluir', itemTabela, atualizarTabelaServerSide)
		},

		clickCancelar(itemTabela, atualizarTabelaServerSide = null) {
			this.$emit('click-cancelar', itemTabela, atualizarTabelaServerSide)
		},

		clickAtualizar(itemTabela) {
			this.$emit('click-atualizar', itemTabela)
		}
	}
}
</script>